import api from '@/utils/api';

/**
 * Update user currency
 * @param {object} currencyData - The user currency data
 * @returns {Promise}
 */
const updateUserCurrencyApi = (currencyData) =>
  api.patch(`/user/my-account/currency`, currencyData);

export default updateUserCurrencyApi;
